<template>
  <!-- main section -->
  <section class="hero is-flex main">
    <bread-crumb :children="breadCrumbs" />
    <b-loading v-model="isLoading" :is-full-page="true"></b-loading>
    <div class="title is-capitalized" v-if="fetchCurrentCategory">
      {{ fetchCurrentCategory.name }}
    </div>
    <div
      class="card is-relative"
      v-if="fetchCurrentCategory && fetchCategories"
    >
      <div class="img1 icon">
        <img src="../assets/images/phone.png" alt="" />
      </div>
      <div class="img2 icon"><img src="../assets/images/six.png" alt="" /></div>
      <div class="img3 icon"><img src="../assets/images/owl.png" alt="" /></div>
      <div class="img4 icon"><img src="../assets/images/two.png" alt="" /></div>
      <div class="img5 icon">
        <img src="../assets/images/stars.png" alt="" />
      </div>
      <div class="card-content">
        <div class="box-container">
          <div
            class="box"
            v-for="(category, i) in fetchCategories"
            :key="category._id"
            :style="
              classroom_id && is_locked[category._id]
                ? 'background: rgb(210 210 210);cursor:not-allowed'
                : null
            "
          >
            <div
              class="box-title"
              @click="goToSkill(category)"
              :style="is_locked[category._id] ? 'cursor:not-allowed' : null"
            >
              {{ i + 1 }}. {{ category.name }}
            </div>
            <div class="box-content">
              <label
                class="switch"
                v-if="
                  classroom_id && (getUserType == 'ST' || getUserType == 'SA')
                "
              >
                <input
                  type="checkbox"
                  v-model="is_locked[category._id]"
                  @change="handleLockUnlock(category._id)"
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import BreadCrumb from "@/components/Common/BreadCrumb";
export default {
  name: "kid-category-skills",
  components: {
    BreadCrumb,
  },
  props: {
    kid_id: {
      type: String,
      required: true,
    },
    grade_subject_id: {
      type: String,
      required: true,
    },
    category_id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      is_locked: {},
      current_tab_index: 0,
    };
  },
  methods: {
    ...mapActions([
      "getUserType",
      "loadCategories",
      "loadCategoryDetails",
      "lockUnlockCategory",
      "loadKidDetails",
    ]),
    maxUpscoreOfSkill(responses) {
      if (responses && responses.length) {
        return Math.max(...responses.map((response) => response.upscore));
      } else {
        return null;
      }
    },
    goToSkill(category) {
      if (!category.is_not_allowed) {
        return this.$router.push({
          name: "kiddetail_category_skills",
          params: {
            kid_id: this.$route.params.kid_id,
            grade_subject_id: this.$route.params.grade_subject_id,
            category_id: category._id,
          },
        });
      }
    },
    handleLockUnlock(id) {
      this.lockUnlockCategory({
        token: this.getTeacherToken,
        data: {
          classroom: this.classroom_id,
          category: id,
          is_locked: this.is_locked[id],
        },
      });
    },
  },
  watch: {
    fetchCategories(new_val) {
      if (new_val.length) {
        for (let c of new_val) {
          this.is_locked[c._id] = c.is_locked;
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      "getUserType",
      "getTeacherToken",
      "fetchCurrentCategory",
      "fetchCategories",
      "fetchCurrentKid",
    ]),
    themeColor() {
      let color = "#000";
      if (
        this.fetchCurrentCategory &&
        this.fetchCurrentCategory.grade_subject &&
        this.fetchCurrentCategory.grade_subject.grade
      ) {
        color = this.fetchCurrentCategory.grade_subject.grade.theme_color;
      }
      return color;
    },
    breadCrumbs() {
      if (this.fetchCurrentCategory && this.fetchCurrentKid) {
        return [
          {
            title: this.fetchCurrentKid.name,
            url: `/kid/${this.kid_id}/practice`,
          },
          {
            title: `${this.fetchCurrentCategory.grade_subject.grade.name} ${this.fetchCurrentCategory.grade_subject.subject.name}`,
            url: `/kid/${this.kid_id}/practice/${this.grade_subject_id}/category`,
          },
          {
            title: `${this.fetchCurrentCategory.name}`,
            url: window.location.href,
          },
        ];
      }

      return [];
    },
  },
  created() {
    this.isLoading = true;
    let urlParams = new URLSearchParams(window.location.search);
    this.classroom_id = urlParams.get("classroom_id");

    Promise.all([
      this.loadKidDetails({
        token: this.getTeacherToken,
        id: this.kid_id,
      }),
      this.loadCategoryDetails({
        token: this.getTeacherToken,
        id: this.category_id,
      }),
      this.loadCategories({
        token: this.getTeacherToken,
        filter: {
          classroom: this.classroom_id,
          parent: this.category_id,
        },
      }),
    ]).finally(() => {
      this.isLoading = false;
    });
  },
};
</script>
<style scoped>
.flex {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.container {
  position: relative;
}

.bg-img {
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}
.bg-img div {
  display: flex;
  position: absolute;
  width: auto;
}

.title {
  font-size: 3vw;
  margin: 0 !important;
}

img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.button {
  flex-direction: row;
  padding: 1vw 1.25vw;
  width: 100%;
  background: #8919e7;
  border-radius: 1vw;
  color: #fff;
  gap: 1vw;
  cursor: pointer;
  position: relative;
  text-transform: capitalize;
}
.button.outline {
  border: 0.063rem solid #8919e7;
  background: #fff;
  color: #000;
}
.link {
  cursor: pointer;
}

.main {
  align-items: center;
  margin: 0vw 0vw;
  position: relative;
  gap: 2.4vw;
}
/* responsive page*/

/* tablet */
@media screen and (max-width: 1023px) {
  .title {
    font-size: 3.5vw !important;
  }
}

/* Mobiles */
@media screen and (max-width: 767px) {
  .title {
    font-size: 4vw !important;
  }
}

@media screen and (max-width: 467px) {
  .title {
    font-size: 5vw !important;
  }
}
.icon {
  position: absolute;
  height: 200px;
  max-width: 100%;
  width: auto;
  z-index: 5;
}

.img1 {
  top: -19%;
  right: 68%;
}

.img3 {
  top: -28%;
  left: 80%;
}
.img3 img {
  height: 169px;
}

.img2 {
  bottom: 35px;
  left: 22px;
}

.img4 {
  bottom: 2%;
  right: 5px;
  z-index: -1;
}

.img5 {
  top: 60%;
  left: 72%;
  z-index: 0;
}
.img5 img {
  height: auto;
}

.main {
  position: relative;
  padding: 8% 3.75% 0px;
  justify-content: center;
  align-items: center;
}
.main .card {
  box-shadow: none;
  background: linear-gradient(
    75.66deg,
    rgba(137, 25, 231, 0.1) 9.81%,
    rgba(49, 199, 255, 0.1) 95.1%
  );
  border-radius: 30px 30px 0px 0px;
  width: 100%;
}
.main .card .card-content {
  display: flex;
  background-image: url(../assets/images/cloud4.png);
  flex-direction: column;
  align-items: center;
  padding: 72px;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
  min-height: 600px;
}

.main .box-container {
  display: flex;
  gap: 32px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
}
.main .box-container .box {
  background: linear-gradient(white, white) padding-box,
    linear-gradient(58.3deg, #8919e7 -30%, #31c7ff 75%) border-box;
  border: 2px solid transparent;
  border-radius: 15px;
  padding: 0;
  width: 320px;
  text-align: center;
  aspect-ratio: 361/217;
  margin: 0;
}
.main .box-container .box .box-title {
  padding: 16px 31px;
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  letter-spacing: 0.1em;
  color: #8919e7;
  cursor: pointer;
  border-bottom: 1px solid #e1e1e1;
}
.main .box-container .box .box-content {
  padding: 36px 121px;
  display: flex;
  gap: 20px;
}
.main .box-container .box .box-content .badge {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  background: rgba(137, 25, 231, 0.12);
  border-radius: 50%;
  padding: 5px;
}
.main .box-container .box .box-content .badge img {
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
}
.main .box-container .box .box-content .score {
  font-weight: 600;
  font-size: 18px;
  line-height: 23px;
  text-transform: capitalize;
  color: #000000;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.main .box-container .box .box-content .score span:last-child {
  color: #31c7ff;
}

@media screen and (max-width: 1024px) {
  .icon {
    height: 150px !important;
  }
  .img3 {
    top: -20%;
  }
  .img3 img {
    height: 105px;
  }
}
@media screen and (max-width: 768px) {
  .card-content {
    padding: 20px !important;
  }
  .columns {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .columns .column {
    width: 100%;
  }
  .icon {
    display: none;
  }
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
